export default __webpack_public_path__ + "static/media/bg2.28a7f845.png";